import { CommandType } from "../../../../common/services/cqs/CommandType";
import { ILeverantor } from "../../../virkeskop/virkesleverantor/models/virkesleverantorModel";
import { LeverantorCommandBase } from "./LeverantorCommandBase";

export class CreateVirkesleverantorCommand extends LeverantorCommandBase {
    namn: string;
    orgNummer: string;
    momsnummerKontrollerat: string;
    momskod: string;
    momsnummerValideringstid?: string;
    momsregistreringsnummer: string;
    momsnummerValideringsstatus?: string;
    adress?: string;
    adress2?: string;
    postnummer?: string;
    postort?: string;
    kontaktFornamn?: string;
    kontaktEfternamn?: string;
    kontaktTypAvKontakt?: string;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateVirkesleverantorCommand";

    constructor(avtalGuid: string, leverantor: ILeverantor) {
        super(avtalGuid, leverantor.guid ?? "", CreateVirkesleverantorCommand.$type, CommandType.Insert);
        this.namn = leverantor.namn;
        this.orgNummer = leverantor.persOrgNummer;
        this.momsnummerValideringstid = leverantor.momsnummerValideringstid;
        this.momsnummerKontrollerat = leverantor.momsnummerKontrollerat;
        this.momskod = leverantor.momskod;
        this.momsregistreringsnummer = leverantor.momsregistreringsnummer;
        this.momsnummerValideringsstatus = leverantor.momsnummerValideringsstatus;
        this.adress = leverantor.adress;
        this.postnummer = leverantor.postnummer;
        this.postort = leverantor.postort;
        this.adress2 = leverantor.adress2;
        this.kontaktFornamn = leverantor.kontaktFornamn;
        this.kontaktEfternamn = leverantor.kontaktEfternamn;
        this.kontaktTypAvKontakt = leverantor.kontaktTypAvKontakt;
    }
}
